var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 22.6C11.35 21.6 11.5 20.7 11.8 19.9C12.1333 19.1 12.5333 18.3833 13 17.75C13.5 17.1167 14.0167 16.55 14.55 16.05C15.1167 15.5167 15.6333 15.0167 16.1 14.55C16.6 14.0833 17 13.6167 17.3 13.15C17.6333 12.6833 17.8 12.2 17.8 11.7C17.8 10.9333 17.4667 10.35 16.8 9.95C16.1667 9.55 15.3833 9.35 14.45 9.35C13.3833 9.35 12.3833 9.65 11.45 10.25C10.5167 10.85 9.78333 11.6833 9.25 12.75L0.35 8.3C1.61667 5.9 3.53333 3.95 6.1 2.45C8.66667 0.949999 11.95 0.199999 15.95 0.199999C18.5833 0.199999 20.9167 0.566666 22.95 1.3C25.0167 2 26.65 3.06666 27.85 4.5C29.05 5.9 29.65 7.65 29.65 9.75C29.65 11.0167 29.45 12.1333 29.05 13.1C28.6833 14.0667 28.1833 14.9167 27.55 15.65C26.95 16.35 26.3167 17 25.65 17.6C24.9833 18.2 24.3333 18.7667 23.7 19.3C23.1 19.8 22.6 20.3167 22.2 20.85C21.8333 21.3833 21.65 21.9667 21.65 22.6H11.35ZM16.5 36.5C14.5667 36.5 12.9833 35.9167 11.75 34.75C10.5167 33.55 9.9 32.1333 9.9 30.5C9.9 28.8333 10.5167 27.4333 11.75 26.3C12.9833 25.1667 14.5667 24.6 16.5 24.6C18.4667 24.6 20.05 25.1667 21.25 26.3C22.4833 27.4333 23.1 28.8333 23.1 30.5C23.1 32.1333 22.4833 33.55 21.25 34.75C20.05 35.9167 18.4667 36.5 16.5 36.5Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.611ea2c4a2258fdb749346f9c25a7c90.svg";
export { ForwardRef as ReactComponent };